import { useMemo } from 'react';
import { isNumber } from 'lodash';

import {
   Bean,
   getCustomFormattingContext,
   MoneyPatternType,
   priceFormatter,
   ValidationRules,
} from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps, useInteractiveTableContext } from '@dreryk/react-components';

import {
   ReceptionServicePractitionerIndividualPrice,
   ReceptionServicePractitionerValue,
} from '../../receptionServicePractitioner.types';
import { usingDefaultConfigurationVisitor } from '../ReceptionServicePractitionersInteractiveTable.utils';

type ReceptionServicePractitionerIndividualPriceCellProps = InteractiveTableCellProps<ReceptionServicePractitionerIndividualPrice | null> & {
   readonly defaultValue: ReceptionServicePractitionerIndividualPrice | null;
};

export const ReceptionServicePractitionerIndividualPriceCell = (
   props: ReceptionServicePractitionerIndividualPriceCellProps
): JSX.Element => {
   const { getCellValue } = useInteractiveTableContext<ReceptionServicePractitionerValue>();
   const usingDefaultConfiguration = getCellValue('usingDefaultConfiguration', props.index);

   const validationRules = useMemo<ValidationRules<Bean>>(() => {
      return {
         required: !usingDefaultConfiguration,
      };
   }, [usingDefaultConfiguration]);

   return usingDefaultConfigurationVisitor(usingDefaultConfiguration)({
      withDefaultConfiguration: () => (
         <InteractiveTable.TextViewCell
            name={props.name}
            testId={props.testId}
            defaultValue={props.defaultValue}
            index={props.index}
            validationRules={validationRules}
            renderer={(value) =>
               isNumber(value)
                  ? priceFormatter(
                       value,
                       getCustomFormattingContext({ options: { currency: 'PLN', stripDecimalZeroes: true } })
                    )
                  : value
            }
         />
      ),
      withIndividualConfiguration: () => (
         <InteractiveTable.MoneyInputCell
            testId={props.testId}
            name={props.name}
            index={props.index}
            validationRules={validationRules}
            defaultValue={props.defaultValue}
            minSize={5}
            maxSize={9}
            min={1}
            max={999999.99}
            pattern={MoneyPatternType.POSITIVE}
         />
      ),
   });
};
